var _path, _line, _path2, _line2, _line3;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgHomeChargers(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 114,
    height: 85,
    viewBox: "0 0 114 85",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M68.5 50.5H76C79.1667 50.3333 85.5 52 85.5 60C85.5 70 83.5 82.5 94.5 83C103.3 83.4 103.5 74 103.5 69V34M94.5 16H112C113 21.3333 112.7 32 103.5 32C94.3 32 93.6667 21.3333 94.5 16Z",
    stroke: "#E4032D",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 7.5,
    y1: 71.5,
    x2: 76.5,
    y2: 71.5,
    stroke: "#E4032D",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.5 42.5L14 39.5V62H33V39.5H51V62H68.5V39.5L73.5 42.5L82 32L68.5 22.5V6.5H54.5V12L41.5 1.5L1.5 32L9.5 42.5Z",
    stroke: "#E4032D",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    x1: 98.5,
    y1: 14.5,
    x2: 98.5,
    y2: 7.5,
    stroke: "#E4032D",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    x1: 107.5,
    y1: 14.5,
    x2: 107.5,
    y2: 7.5,
    stroke: "#E4032D",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHomeChargers);
export default __webpack_public_path__ + "static/media/home-chargers.2fa343a026ca1fb00a35dcb528bfe0d9.svg";
export { ForwardRef as ReactComponent };